module.exports = __webpack_public_path__ + "96a111619e0ed7e5a0ffe76723efaed6.pdf";